import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateHelper } from 'src/app/helpers/date-helper';
import { PropertyType } from 'src/app/models/enums/property-type';
import { ColumnDefinition } from 'src/app/models/server/column-definition';
import { Folder } from 'src/app/models/server/folder';

@Pipe({
    name: 'avmFolderCellPipe',
    standalone: true,
    pure: true,
})
export class AvmFolderCellPipe implements PipeTransform {
    constructor(protected datePipe: DatePipe) {}

    /**
     * Formate une cellule de la liste des dossiers.
     * @param folder : Instance du dossier affiché par la ligne contenant la cellule.
     * @param columnDefinition : Définition de la colonne affichant la cellule
     */
    transform(folder: Folder, columnDefinition: ColumnDefinition): string {
        //console.count(`AvmFolderCellPipe - transform ${folder.id} - ${columnDefinition.header}`);

        if (columnDefinition.type !== PropertyType.Workflow) {
            return this.formatAttributeData(columnDefinition, folder);
        } else {
            return this.formatWorkflowData(columnDefinition, folder);
        }
    }

    /**
     * Formatte une donnée métier, de type 'Attribut', affichée dans une cellule de la liste des données.
     * @param columnDefinition : Definition de la colonne à laquelle appartient la cellule.
     * @param folder : Donnée métier affichée par la cellule.
     * @returns La donnée formattée pour l'affichage.
     */
    private formatAttributeData(columnDefinition: ColumnDefinition, folder: Folder): string {
        if (columnDefinition.custom) {
            if (columnDefinition.type === PropertyType.List || columnDefinition.type === PropertyType.ListCustomers || columnDefinition.type === PropertyType.ListUsers) {
                if (folder.customAttributes[columnDefinition.propertyCode]) {
                    return `${columnDefinition.values.find((x) => x.value == folder.customAttributes[columnDefinition.propertyCode]).text}`;
                } else {
                    return '';
                }
            } else {
                let renderedValue = folder.customAttributes[columnDefinition.propertyCode];

                if (columnDefinition.displayFormat) {
                    switch (columnDefinition.displayFormat) {
                        case 'XXXXXXXXXX':
                            renderedValue = this.getFormatedPhoneNumber(renderedValue, '');
                            break;
                        case 'XX XX XX XX XX':
                            renderedValue = this.getFormatedPhoneNumber(renderedValue, ' ');
                            break;
                        case 'XX.XX.XX.XX.XX':
                            renderedValue = this.getFormatedPhoneNumber(renderedValue, '.');
                            break;
                        case 'XX-XX-XX-XX-XX':
                            renderedValue = this.getFormatedPhoneNumber(renderedValue, '-');
                            break;
                        default:
                            renderedValue = renderedValue;
                    }
                }

                if (renderedValue) {
                    return renderedValue;
                } else {
                    return '';
                }
            }
        } else {
            if (columnDefinition.type === PropertyType.List || columnDefinition.type === PropertyType.ListCustomers || columnDefinition.type === PropertyType.ListUsers) {
                if (folder[columnDefinition.propertyCode]) {
                    return `${columnDefinition.values.find((x) => x.value == folder[columnDefinition.propertyCode]).text}`;
                } else {
                    return '';
                }
            } else {
                let renderedValue = folder[columnDefinition.propertyCode];

                if (renderedValue) {
                    return renderedValue;
                } else {
                    return '';
                }
            }
        }
    }

    /**
     * Formatte une donnée métier, de type 'Etape de workflow', affichée dans une cellule de la liste des données.
     * @param columnDefinition : Definition de la colonne à laquelle appartient la cellule.
     * @param columnDefinition : Donnée métier affichée par la cellule.
     * @param folder : Donnée métier associée à la ligne auquelle appartient la cellule.
     * @returns La donnée formattée pour l'affichage.
     */
    private formatWorkflowData(columnDefinition: ColumnDefinition, folder: Folder): string {
        const workflowStepsSnapshot = folder.workflowStepsSnapshot.find((x) => x.workflowStepId.toString() == columnDefinition.propertyCode);
        var data = !!workflowStepsSnapshot
            ? `${workflowStepsSnapshot.currentStateName} (${this.datePipe.transform(workflowStepsSnapshot.currentStateDate, DateHelper.FRENCH_DATETIME_FORMAT)})`
            : 'N/A';
        return data;
    }

    private getFormatedPhoneNumber(phoneNumber: string, separator: string): string {
        if (phoneNumber) {
            let parts = this.splitPhoneNumber(phoneNumber);
            return parts.join(separator);
        } else {
            return null;
        }
    }

    private splitPhoneNumber(phoneNumber: string): string[] {
        let parts: string[] = [];
        let reversePhoneNumber = phoneNumber.split('').reverse().join('');
        parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
        reversePhoneNumber = reversePhoneNumber.substring(2);
        parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
        reversePhoneNumber = reversePhoneNumber.substring(2);
        parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
        reversePhoneNumber = reversePhoneNumber.substring(2);
        parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
        reversePhoneNumber = reversePhoneNumber.substring(2);
        if (reversePhoneNumber.length === 2) {
            parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
            reversePhoneNumber = reversePhoneNumber.substring(2);
        } else {
            let lastPart = reversePhoneNumber.substring(0, 1).split('').reverse().join('');
            reversePhoneNumber = reversePhoneNumber.substring(1);
            let indicatif = `(${reversePhoneNumber.split('').reverse().join('')})`;
            parts.push(`${indicatif} ${lastPart}`);
        }

        return parts.reverse();
    }
}
